import { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";

/**
 * Iter462 — Shared read-only gate for every organiser-facing festival
 * surface. Reuses the exact logic Iter461 introduced inline in
 * `FestivalPlayers.jsx` so Live Ops, Helper Passes, and any future
 * surface stay consistent.
 *
 * Returns `isReadOnly === true` when the festival's `end_at` has
 * passed AND the viewer is NOT a Rally-Lab platform admin. Platform
 * admins (role === "admin" or `permissions` includes `admin`
 * /`super_admin`) always keep full write access.
 */
export function useFestivalReadOnly(festival) {
  const { user } = useAuth();
  return useMemo(() => {
    const isPlatformAdmin = user?.role === "admin"
      || (user?.permissions || []).some((p) => p === "admin" || p === "super_admin");
    const end = festival?.end_at;
    let festivalEnded = false;
    if (end) {
      try { festivalEnded = new Date(end).getTime() < Date.now(); } catch { /* ignore */ }
    }
    return {
      isPlatformAdmin,
      festivalEnded,
      isReadOnly: festivalEnded && !isPlatformAdmin,
    };
  }, [user, festival?.end_at]);
}
